














import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { MetaInfo } from 'vue-meta';

import { NoRobots } from '@/constants/meta';
import XsollaWidget from '@/components/xsolla/XsollaWidget.vue';
import LocaleMixin from '@/mixins/locale';

import {
  PROJECT_IDS as projectIds,
  CLIENT_IDS as clientIds,
  CALLBACK_URL as callbackUrl,
  REDIRECT_URI as redirectUri,
  SETTINGS_JSON_URL as settingsJsonUrl,
  SOCIALS_JSON_URL as socialsJsonUrlRu,
} from '@/config/xsolla';

import { ISO_LOCALES } from '@/locales';
import { Apps } from '@/constants/apps';
import { buildStateParamsString } from '@/helpers/auth';

@Component({
  metaInfo(): MetaInfo {
    return {
      meta: [NoRobots],
    };
  },
  components: { XsollaWidget },
})
export default class Auth extends mixins(LocaleMixin) {
  state: string = '';

  beforeMount() {
    if (this.$appName === undefined) {
      return;
    }
    this.$oauth.refreshState(this.$appName);
  }

  get projectId() {
    if (this.$appName === undefined) {
      return undefined;
    }
    return projectIds[this.$appName];
  }

  get clientId() {
    if (this.$appName === undefined) {
      return undefined;
    }
    return clientIds[this.$appName];
  }

  get callbackUrl() {
    return callbackUrl;
  }

  get redirectUri() {
    return redirectUri;
  }

  get settingsJsonUrl(): string | null {
    if (this.$appName !== Apps.Township) {
      return settingsJsonUrl || null;
    }
    return null;
  }

  get socialsJsonUrl(): string | null {
    if (this.locale === 'ru' && socialsJsonUrlRu && this.$appName !== Apps.Township) {
      return socialsJsonUrlRu;
    }
    return null;
  }

  get preferredLocale() {
    return ISO_LOCALES[this.locale];
  }

  get stateParams() {
    return buildStateParamsString({
      state: this.state,
      from: this.$route.params.from,
    });
  }
}
